// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-class{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));font-weight:600;border-radius:2rem;transition-property:background-color,border-color,color,fill,stroke;transition-duration:.3s}@media (min-width:768px){.button-class{font-size:1.125rem;line-height:1.5rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
